export default {
  state: {
    mainIcon: {
      background: '#ff2f00',
      icon: 'https://static.dnipro-m.pl/origin/chat/messenger-1.svg',
      closeIcon: 'https://static.dnipro-m.pl/origin/chat/interface-1.svg',
      closeBackground: '#fff'
    },
    chats: [
      {
        id: 1,
        name: 'chat',
        label: 'chat_label',
        background: '#ff2f00',
        icon: 'https://static.dnipro-m.pl/origin/chat/messenger-1.svg',
        link: '#'
      }
    ],
    isOpen: true
  },
  mutations: {
    OPEN_CHATS_LIST (state, bool) {
      state.isOpen = bool
    }
  },
  actions: {
    SET_CHATS_LIST_STATUS: (ctx, bool) => {
      ctx.commit('OPEN_CHATS_LIST', bool)
    }
  }
}
